export default "__VITE_ASSET__DrqXSosN__"